module.exports = __webpack_public_path__ + "img/05.643d4757.png";